<template>
  <div class="bg-brand-light-gray flex flex-col md:py-12">
    <div
      class="w-full md:max-w-screen-sm flex flex-col bg-white rounded-sm shadow mx-auto py-10 px-10 mt-5"
    >
      <h2 class="text-2xl py-1">Reset Your Password</h2>

      <p class="py-3">Please enter a new password for your account</p>
      <div class="flex flex-col py-2 relative">
        <label for="website" class="block"> New Password </label>
        <SingleLineInput
          id="newPassword"
          :type="newPasswordShow ? 'text' : 'password'"
          :value="newPassword"
          @input="newPassword = $event.target.value"
        ></SingleLineInput>

        <EyeIcon
          class="absolute h-7 w-7 text-brand-green top-12 right-3 z-50 cursor-pointer"
          v-if="!newPasswordShow"
          @click="toggleShowNewPassword"
        />
        <EyeOffIcon
          v-else
          class="absolute h-7 w-7 text-brand-dark-gray top-12 right-3 z-50 cursor-pointer"
          @click="toggleShowNewPassword"
        />
      </div>

      <div class="flex flex-col py-2 relative">
        <label for="website" class="block"> Confirm New Password </label>
        <SingleLineInput
          id="matchPassword"
          :type="matchPasswordShow ? 'text' : 'password'"
          :value="matchPassword"
          @input="matchPassword = $event.target.value"
        ></SingleLineInput>

        <EyeIcon
          class="absolute h-7 w-7 text-brand-green top-12 right-3 z-50 cursor-pointer"
          v-if="!matchPasswordShow"
          @click="toggleShowMatchPassword"
        />
        <EyeOffIcon
          v-else
          class="absolute h-7 w-7 text-brand-dark-gray top-12 right-3 z-50 cursor-pointer"
          @click="toggleShowMatchPassword"
        />
      </div>

      <PasswordGuide :password="matchPassword" ref="passwordGuide" />

      <div class="flex flex-col w-full md:w-1/2 mx-auto py-5">
        <PrimaryButton
          @click="resetPassword"
          :disabled="!passwordValid || isUserLoading"
          :is-loading="isUserLoading"
          >Reset Password
        </PrimaryButton>
      </div>
    </div>
  </div>
  <ActionToast ref="passwordResetToast" />
</template>
<script>
import { mapGetters } from "vuex"
import { USER_CONFIRM_PASSWORD_RESET } from "@/store/types"

import { EyeIcon, EyeOffIcon } from "@heroicons/vue/outline"

export default {
  components: {
    EyeIcon,
    EyeOffIcon
  },
  computed: {
    ...mapGetters(["isUserLoading"]),
    passwordValid() {
      return (
        !!this.newPassword &&
        !!this.matchPassword &&
        this.newPassword === this.matchPassword &&
        this.$refs.passwordGuide.isValid
      )
    }
  },
  data() {
    return {
      newPassword: "",
      matchPassword: "",
      errorMessage: "",
      uidb64: "",
      token: "",
      newPasswordShow: false,
      matchPasswordShow: false
    }
  },
  mounted() {
    if (!this.$route.params.uidb64 || !this.$route.params.token) {
      this.$router.push({ name: "home_password_reset" })
    }
    this.uidb64 = this.$route.params.uidb64
    this.token = this.$route.params.token
  },
  methods: {
    toggleShowNewPassword() {
      this.newPasswordShow = !this.newPasswordShow
    },
    toggleShowMatchPassword() {
      this.matchPasswordShow = !this.matchPasswordShow
    },
    resetData() {
      this.newPassword = ""
      this.matchPassword = ""
      this.errorMessage = ""
    },
    async resetPassword() {
      const { newPassword, matchPassword, uidb64, token } = this

      try {
        await this.$store.dispatch(USER_CONFIRM_PASSWORD_RESET, {
          uidb64,
          token,
          newPassword,
          matchPassword
        })

        this.$router.push({ name: "home_password_reset_done" })
      } catch (err) {
        if (err.response && err.response.data.__all__) {
          this.errorMessage = err.response.data.__all__[0]
        } else {
          this.errorMessage = "Error has occurred. Please try again."
        }
        this.$refs.passwordResetToast.show({
          type: "danger",
          hasClose: true,
          content: this.errorMessage
        })
      }
      this.resetData()
    }
  }
}
</script>
